import React from 'react';
import { Form, DatePicker, Input, Select, Modal } from '@block/plug';
import { datejs, isEmpty } from '@block/utils';
import { Card, Company, HoverText } from '@src/components';
// import Url from './url';
import { getPattern, doAction, compareDate } from '../../../utils';
import Url from '../url';

interface Props {
  data: any;
  getRef: any;
  index: number;
  onChange: (a: any, b: any, c: any) => void;
  onDelete: (e: any) => void;
  showRefer?: any;
  // eslint-disable-next-line react/no-unused-prop-types
  ifUpgrade?: boolean;
}

interface State {
  leaveReasonStatus: boolean;
  attrsStatus: boolean;
}
class Works extends React.Component<Props, State> {
  formRef: React.RefObject<any>;

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = { leaveReasonStatus: true, attrsStatus: true };
  }

  async componentDidMount() {
    const { data, getRef, index } = this.props;
    getRef?.(this.formRef, index);
    this.handleSetData(data);
  }

  componentWillReceiveProps(props) {
    const { data } = props;
    this.handleSetData(data);
  }

  handleSetData = (data) => {
    const { leaveReasonIndex, endDate } = data;
    const period = !endDate || datejs(new Date().getTime()).diff(datejs(endDate), 'month') > 60;
    this.setState({
      leaveReasonStatus: leaveReasonIndex !== 101,
      attrsStatus: period,
    });
    this.formRef.current?.setAllFieldsValue(data);
  };

  handleDelete = () => {
    const { onDelete, index } = this.props;

    // 使用 Modal.confirm 进行二次确认
    Modal.confirm({
      title: '删除警告',
      message: `确定要删除该记录吗？`,
      onOk() {
        // 用户点击确认，执行删除
        if (typeof onDelete === 'function') {
          onDelete(index);
        }
      },
    });
  };

  handleValidate = () => [
    { required: true, message: '不能为空' },
    {
      validator(rule, value, callback) {
        const pattern = getPattern('(^(?!\\s*$))[\\s\\S]{1,50}?$');
        if (pattern && !pattern.test(value)) {
          callback('请输入1~50个字符');
        } else if (isEmpty(value)) {
          callback('不能为空');
        } else {
          callback();
        }
      },
    },
  ];

  handleFetchData = async (filter = '', type = undefined) => {
    let url = '';
    if (type === 'nationality') {
      // 国家
      url = Url.getNationality;
    }
    if (type === 'leave') {
      // 离职原因
      url = Url.getLeaveReasons;

      const data = await doAction(url, {
        filter,
      });
      return data;
    }

    const data = await doAction(url, {
      filter,
    });
    return data.pageList;
  };

  handleFieldValueChange = (code, value, fieldsValue) => {
    const ref = this.formRef.current;
    const { onChange, index } = this.props;
    if (code === 'leaveReasonIndex') {
      this.setState({
        leaveReasonStatus: value !== 101,
      });
      ref?.setFieldsValue({
        leaveReasonValue: fieldsValue.leaveReasonValue,
      });
    }
    if (code === 'competitionAgreeStartDate') {
      const { competitionAgreeEndDate } = ref.getFieldsValueIncludeHide();
      if (compareDate(value, competitionAgreeEndDate)) {
        ref.clearValidateStatus(['competitionAgreeEndDate']);
      } else {
        ref?.validateFields(['competitionAgreeEndDate']);
      }
      ref?.setFieldsValue({
        competitionAgreeStartDateStr: value ? datejs(value).format('YYYY-MM-DD') : null,
      });
    }
    if (code === 'competitionAgreeEndDate') {
      ref?.setFieldsValue({
        competitionAgreeEndDateStr: value ? datejs(value).format('YYYY-MM-DD') : null,
      });
    }
    if (code === 'startDate') {
      const startDate = value ? datejs(value).set('date', 1).valueOf() : null;
      const startDateStr = value ? datejs(value).set('date', 1).format('YYYY-MM-DD') : null;
      ref?.setFieldsValue({
        startDate,
        startDateStr,
      });
      const { endDate } = ref.getFieldsValueIncludeHide();
      if (compareDate(value, endDate)) {
        ref.clearValidateStatus(['endDate']);
      } else {
        ref?.validateFields(['endDate']);
      }
    }
    if (code === 'endDate') {
      const endDate = value ? datejs(value).set('date', 1).valueOf() : null;
      const endDateStr = value ? datejs(value).set('date', 1).format('YYYY-MM-DD') : null;
      ref?.setFieldsValue({
        endDate,
        endDateStr,
      });
      const period = !value || datejs(new Date().getTime()).diff(datejs(value), 'month') > 60;
      this.setState({ attrsStatus: period });
    }
    const formData = ref.getFieldsValueIncludeHide();
    if (typeof onChange === 'function') onChange(formData, index, this.formRef);
  };

  render() {
    const { showRefer } = this.props;
    const { leaveReasonStatus, attrsStatus } = this.state;
    const notNeedCheck = window.checkTypeIndex === 0;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    return (
      <Card onDelete={this.handleDelete}>
        <Form
          ref={this.formRef}
          labelWidth="110px"
          onFieldValueChange={this.handleFieldValueChange}
          className="works__card"
        >
          <Form.Item labelWidth={0} span={20}>
            <span className="base-form__subtitle">工作经历</span>
          </Form.Item>
          <Form.Item
            formItemKey="company"
            span={11}
            label={
              <HoverText message="请填写劳动合同/离职证明上的公司名称，请勿填写简称、俗称。" extra="：">
                公司名称
              </HoverText>
            }
            rules={this.handleValidate()}
          >
            <Company toFormItem />
          </Form.Item>

          <Form.Item
            labelWidth="114px"
            formItemKey="companyAreaDict"
            labelInValue={false}
            formItemLabel="companyAreaName"
            offset={2}
            span={11}
            required
            message="不能为空"
            label="工作国家/地区："
          >
            <Select
              toFormItem
              filterable
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={(filter) => this.handleFetchData(filter, 'nationality')}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.works__card'),
              }}
            />
          </Form.Item>

          <Form.Item formItemKey="position" span={11} label="职位：" rules={this.handleValidate()}>
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item
            formItemKey="jobLevel"
            span={11}
            offset={2}
            label="职级："
            rules={this.handleValidate()}
            labelWidth="114px"
          >
            <Input toFormItem placeholder='没有或忘记，请填"无"' maxLength={50} />
          </Form.Item>

          <Form.Item formItemKey="startDate" span={7} required message="不能为空" label="工作起止时间：">
            <span className="base-form__flex">
              <DatePicker
                toFormItem
                format="YYYY-MM"
                valueFormat="timestamp"
                placeholder="开始时间"
                popLayer={{
                  getContainer: () => document.querySelector('.works__card'),
                }}
              />
              <span className="base-form__line" />
            </span>
          </Form.Item>
          <Form.Item
            className="base-form__space"
            formItemKey="endDate"
            span={4}
            labelWidth={0}
            rules={[
              { required: true, message: '不能为空' },
              {
                validator(rule, value, callback) {
                  const { startDate } = self.formRef.current.getFieldsValueIncludeHide();
                  const endDate = datejs(value).toDate().getTime();
                  if (startDate && endDate < datejs(startDate).toDate().getTime()) {
                    callback('结束时间不能小于开始时间');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <DatePicker
              toFormItem
              format="YYYY-MM"
              valueFormat="timestamp"
              placeholder="结束时间"
              popLayer={{
                getContainer: () => document.querySelector('.works__card'),
              }}
            />
          </Form.Item>

          <Form.Item
            labelWidth="114px"
            formItemKey="hasBreakRules"
            span={11}
            offset={2}
            required
            message="不能为空"
            label="有无违纪记录："
          >
            <Input toFormItem maxLength={50} placeholder='没有请填"无"' />
          </Form.Item>

          <Form.Item
            formItemKey="leaveReasonIndex"
            labelInValue={false}
            formItemLabel="leaveReasonValue"
            span={11}
            required
            message="不能为空"
            label="离职原因："
          >
            <Select
              toFormItem
              filterable
              keyField="id"
              labelField="descr"
              onFetchData={(filter) => this.handleFetchData(filter, 'leave')}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.works__card'),
              }}
            />
          </Form.Item>
          <Form.Item
            formItemKey="leaveReasonOther"
            span={11}
            offset={2}
            label="原因说明："
            hide={leaveReasonStatus}
            rules={[
              { required: true, message: '不能为空' },
              {
                validator(rule, value, callback) {
                  const pattern = getPattern('(^(?!\\s*$))[\\s\\S]{1,100}?$');
                  if (pattern && !pattern.test(value)) {
                    callback('请输入1~100个字符');
                  } else if (isEmpty(value)) {
                    callback('不能为空');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem maxLength={100} />
          </Form.Item>
          <Form.Item labelWidth={0} hide={showRefer || attrsStatus || notNeedCheck}>
            <span className="base-form__subtitle">
              人事部证明人
              <span className="base-form__desc">（请务必提供人事部在职在岗同事）</span>
            </span>
          </Form.Item>
          <Form.Item
            formItemKey="hrWitnessName"
            span={11}
            hide={showRefer || attrsStatus || notNeedCheck}
            label="姓名："
            rules={this.handleValidate()}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item
            formItemKey="hrWitnessPhone"
            span={11}
            label="手机号："
            offset={2}
            hide={showRefer || attrsStatus || notNeedCheck}
            rules={[
              { required: true, message: '证明人电话不能为空' },
              {
                validator(rule, value, callback) {
                  const pattern = getPattern('^([0-9]{3,24})$');
                  if (pattern && !pattern.test(value)) {
                    callback('请输入格式正确的电话');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item
            formItemKey="hrWitnessPosition"
            span={11}
            hide={showRefer || attrsStatus || notNeedCheck}
            label="职位："
            rules={this.handleValidate()}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>

          <Form.Item labelWidth={0} hide={showRefer || attrsStatus || notNeedCheck}>
            <span className="base-form__subtitle">
              直接主管证明人
              <span className="base-form__desc">(请务必提供您在该公司的最后一任上级)</span>
            </span>
          </Form.Item>
          <Form.Item
            formItemKey="managerWitnessName"
            span={11}
            hide={showRefer || attrsStatus || notNeedCheck}
            label="姓名："
            rules={this.handleValidate()}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item
            formItemKey="managerWitnessPhone"
            span={11}
            hide={showRefer || attrsStatus || notNeedCheck}
            offset={2}
            label="手机号："
            rules={[
              { required: true, message: '证明人电话不能为空' },
              {
                validator(rule, value, callback) {
                  const pattern = getPattern('^([0-9]{3,24})$');
                  if (pattern && !pattern.test(value)) {
                    callback('请输入格式正确的电话');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item
            formItemKey="managerWitnessPosition"
            span={11}
            hide={showRefer || attrsStatus || notNeedCheck}
            label="职位："
            rules={this.handleValidate()}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__subtitle">同事证明人</span>
          </Form.Item>
          <Form.Item formItemKey="witnessName" span={11} label="姓名：" rules={this.handleValidate()}>
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item
            formItemKey="witnessPhone"
            span={11}
            label="手机号："
            offset={2}
            rules={[
              { required: true, message: '证明人电话不能为空' },
              {
                validator(rule, value, callback) {
                  const pattern = getPattern('^([0-9]{3,24})$');
                  if (pattern && !pattern.test(value)) {
                    callback('请输入格式正确的电话');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item formItemKey="witnessPosition" span={11} label="职位：" rules={this.handleValidate()}>
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item span={11} />
        </Form>
      </Card>
    );
  }
}
export default Works;
